import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import ArchiveJobDescriptionForm from './ArchiveJobDescriptionForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const ArchiveJobDescriptionModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeArchiveJobDescriptionModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.archiveJobDescriptionModalIsOpen}
      contentLabel={'Archive Job Description'}
      onRequestClose={() => {
        closeArchiveJobDescriptionModal();
      }}
    >
      <PageTitle text={'Archive Job Description'} />
      <ArchiveJobDescriptionForm />
    </StandardModal>
  );
};

export default ArchiveJobDescriptionModal;
